require('select2');


const PLACEHOLDER = 'Selecione uma opção';
const NO_RESULTS = 'Nenhum resultado correspondente';
const INPUT_TOO_SHORT = 'Digite 3 ou mais caracteres para buscar';
const MINIMUM_INPUT_LENGTH = 3;
const LANGUAGE = {
    noResults: function(){
        return NO_RESULTS;
    },
    inputTooShort: function () { 
        return INPUT_TOO_SHORT; 
    }
};

export function defaultSelect2(class_name=".select2", withTags = false){
    $(class_name).select2({
        theme: 'bootstrap4',
        placeholder: PLACEHOLDER,
        allowClear: true,
        language: LANGUAGE,
        width: 'style',
        tags: withTags,
        closeOnSelect: true,
    });
}

function defaultSelect2Ajax(class_name, route, parameters={}){
    

    const options = (params) => ({ q: $.trim(params.term), ...parameters }) 

    
    $(class_name).select2({
        placeholder: PLACEHOLDER,
        language: LANGUAGE,
        ajax: {
            url: route,
            dataType: 'json',
            data: function(params){
                return options(params);
            },
            processResults: function (data) {
                return {
                    results: data || null
                };
            },
            results: function (data) {
                return {
                    results: data || null
                };
            },
            transport: function (params, success, failure) {
                var $request = $.ajax(params);
            
                $request.then(success);
                $request.fail(failure);
            
                return $request;
            },
            cache: false
        },
    });
}


defaultSelect2();
defaultSelect2('.select2-tags', true);
